<template>
  <base-page
    :title="title"
  >
    <template #main>
      <model-output-create-update-form :v-model="modelOuput" />
    </template>
  </base-page>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import ModelOutputCreateUpdateForm from '@/views/ModelOutputs/ModelOutputCreateUpdateForm'
import BasePage from "../BasePage"

export default {
  components: {
    BasePage,
    ModelOutputCreateUpdateForm
  },
  data() {
    return {
      modelOuput: { }
    }
  },
  computed: {
    title() {
      return this.modelOuput == null ? this.$t('model_output.page.create_form_title') : this.$t('model_output.page.update_form_title')
    }
  },
  created() {
    // When edit, we send the model when create don't
    this.modelOuput = this.$route.params.model
  },
}
</script>
